import type React from 'react';

import classNames from 'classnames';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { GearIcon } from '../../icons/gear';
import { Tooltip } from '../tooltip/tooltip';

import styles from './settings-menu-button.module.css';

type Props = {
  isActive?: boolean;
  className?: string;
  onClick?: () => void;
};

export function SettingsMenuButton({ isActive, className, onClick }: Props) {
  const { t } = useTranslation();

  const label = isActive ? t('ui.menu.button.label.active') : t('ui.menu.button.label.inactive');
  const button = useCallback(
    (ref: React.LegacyRef<HTMLButtonElement>, props: Record<string, unknown>) => (
      <button
        data-testid="settings-menu-button"
        type="button"
        name="settings-menu-button"
        aria-expanded={isActive}
        aria-haspopup="true"
        className={classNames(styles.menuButton, { [styles.active]: isActive }, className)}
        onClick={onClick}
        ref={ref}
        {...props}
      >
        <GearIcon />
      </button>
    ),
    [className, isActive, onClick]
  );
  return <Tooltip tooltip={label} trigger={button} />;
}
